<form
  id="mu-auth-company-billing-form"
  class="p-grid p-dir-col mu-position-relative mu-form-content"
  [formGroup]="formData"
  appValidator
  *ngIf="formData"
>
  <div class="p-grid container-form mu-full-width">
    <app-mu-form-fieldset [customGridCol]="12" label="businessName" [iconFeedback]="true">
      <input
        type="text"
        businessName="businessName"
        id="businessName"
        formControlName="businessName"
        [placeholder]="'form.placeholder.businessName' | translate"
      />
    </app-mu-form-fieldset>
    <app-mu-form-fieldset
      [customGridCol]="isMX ? 8 : 12"
      label="city"
      [iconFeedback]="true"
      [position]="isMX ? fieldPositionEnum.START : ''"
      [attr.translate]="'no'"
    >
      <app-mu-form-dropdown [formGroup]="formData" field="city" [optionList]="cityList"></app-mu-form-dropdown>
    </app-mu-form-fieldset>
    <app-mu-form-fieldset [customGridCol]="4" label="zipCode" [iconFeedback]="true" *ngIf="isMX" [position]="fieldPositionEnum.END">
      <input type="text" id="zipCode" name="zipCode" formControlName="zipCode" [placeholder]="'form.placeholder.zipCode' | translate" />
    </app-mu-form-fieldset>
    <app-mu-form-fieldset [customGridCol]="12" label="companyDocumentType" [iconFeedback]="true">
      <app-mu-form-dropdown [formGroup]="formData" field="companyDocumentType" [optionList]="documentTypeList"></app-mu-form-dropdown>
    </app-mu-form-fieldset>
    <app-mu-form-fieldset [customGridCol]="isMX ? 12 : 7" label="companyDocumentNumber" [iconFeedback]="true" position="start">
      <input
        type="text"
        businessName="companyDocumentNumber"
        id="companyDocumentNumber"
        formControlName="companyDocumentNumber"
        [placeholder]="'form.placeholder.companyDocumentNumber' | translate"
      />
    </app-mu-form-fieldset>
    <app-mu-form-fieldset [customGridCol]="5" label="verificationCode" [iconFeedback]="true" position="end" *ngIf="!isMX">
      <input
        type="text"
        businessName="verificationCode"
        id="verificationCode"
        formControlName="verificationCode"
        [placeholder]="'form.placeholder.verificationCode' | translate"
        maxlength="1"
      />
    </app-mu-form-fieldset>
    <app-mu-form-fieldset [customGridCol]="12" label="contactName" [iconFeedback]="true">
      <input
        type="text"
        businessName="contactName"
        id="contactName"
        formControlName="contactName"
        [placeholder]="'form.placeholder.contactName' | translate"
      />
    </app-mu-form-fieldset>
    <app-mu-form-fieldset [customGridCol]="12" label="companyPhone" [iconFeedback]="true">
      <input
        type="text"
        businessName="companyPhone"
        id="companyPhone"
        formControlName="companyPhone"
        [placeholder]="'form.placeholder.companyPhone' | translate"
      />
    </app-mu-form-fieldset>
    <app-mu-form-fieldset [customGridCol]="12" label="segmentationRangeId" [iconFeedback]="true">
      <app-mu-form-dropdown
        [formGroup]="formData"
        field="segmentationRangeId"
        [optionList]="segmentationList"
        positionTop="true"
      ></app-mu-form-dropdown>
    </app-mu-form-fieldset>
  </div>
  <app-mu-form-buttons [customGridCol]="12">
    <p-button
      muButtonLeft
      [label]="'form.button.back' | translate"
      class="mu-button mu-button-outline"
      type="button"
      routerLink="/crear-cuenta/datos"
    >
    </p-button>
    <p-button
      muButtonRight
      [label]="'form.button.selfRegister' | translate"
      [disabled]="formData.get('isInvalidForm').value"
      class="mu-button"
      type="button"
      (click)="register()"
    >
      <app-loading [showLoading]="loader" type="icon"></app-loading>
    </p-button>
  </app-mu-form-buttons>
</form>
